import styles from './CaseStudy.module.css';
import { Header } from 'components/Header';
import { FORTIFY_CASE_STUDY_UI_CONFIG } from './ui-configs';
import { CaseStudyUIGenerator, CaseStudyUIGeneratorConfig } from './CaseStudyUIGenerator';
import { FooterSection } from 'components/FooterSection';
import { CaseStudyName } from 'features/Home/CaseStudies/constants';
import { clsx } from 'clsx';
import { useRef } from 'react';

interface CaseStudyProps {
  companyName: CaseStudyName;
}

export const COMPANY_NAME_TO_UI_CONFIG_MAP: Record<CaseStudyName, CaseStudyUIGeneratorConfig[]> = {
  fortify: FORTIFY_CASE_STUDY_UI_CONFIG,
};

export const CaseStudy = ({ companyName }: CaseStudyProps) => {
  const UI_CONFIG = COMPANY_NAME_TO_UI_CONFIG_MAP[companyName];
  const footerSectionRef = useRef<HTMLDivElement>(null);

  const navigateToFooter = (e: React.MouseEvent) => {
    e.preventDefault();
    footerSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className={clsx(styles.caseStudyScopedVariables, styles.pageLayout)}>
      <Header
        theme='glass'
        showMobileNavigation={false}
        isMobileNavigationActive={false}
        logoLinkHref='/'
        letsTalkLink={{
          url: '#lets-talk',
          onClick: navigateToFooter,
        }}
      />
      {UI_CONFIG.map((section, index) => (
        <CaseStudyUIGenerator key={index} {...section} />
      ))}
      <FooterSection ref={footerSectionRef} />
    </div>
  );
};
